<template>
  <Breadcrumbs
      title="New Invoice"
      :breadcrumbs="[
      { label: 'Sales', path: '' },
      { label: 'Invoices', path: '/invoice' },
      { label: 'New Invoice', path: '/new-invoice' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <newInvoiceForm/>
    </div>
  </div>
</template>

<script>
import newInvoiceForm from "@/pages/invoice/newInvoice/newInvoiceForm.vue";
export default {
  name: 'newInvoice',
  components: {
    newInvoiceForm,
  },
}
</script>
